var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 13,
  viewBox: "0 0 15 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#528AEA",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.732 1.467c0-.35-.231-.584-.579-.584H1.415c-.347 0-.578.234-.578.584v1.17c0 .35.231.584.578.584h12.738c.348 0 .58-.234.58-.585V1.467zM11.732 6.143c0-.35-.231-.585-.579-.585H1.415c-.347 0-.578.234-.578.585v1.169c0 .35.231.584.578.584h9.738c.348 0 .58-.234.58-.584v-1.17zM8.732 10.818c0-.35-.231-.584-.579-.584H1.415c-.347 0-.578.234-.578.584v1.17c0 .35.231.584.578.584h6.738c.348 0 .58-.234.58-.585v-1.169z"
}))));
export default __webpack_public_path__ + "teg/media/menu.064e8658.svg";
export { SvgComponent as ReactComponent };